import { FC } from 'react';
import { ButtonTheme } from './button-theme';
import { getThemeClasses } from './button-functions';

export interface AnchorButtonProps {
  theme: ButtonTheme;
  href: string;
  children: JSX.Element | JSX.Element[];
}

const AnchorButton: FC<AnchorButtonProps> = ({
  theme,
  href,
  children
}: AnchorButtonProps) => {
  const themeClasses = getThemeClasses(theme);

  return (
    <a
      href={href}
      className={`block relative transition-all text-sm rounded text-center ${themeClasses}`}
    >
      {children}
    </a>
  );
};

export default AnchorButton;
